<template>
    <v-card class="pa-3 ma-md-3">
        <loader v-if="isloading"></loader>
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-account-supervisor-circle</v-icon
            >
            <pre><v-toolbar-title><h2>Lista de presupuestos</h2></v-toolbar-title></pre>
        </v-toolbar>
        <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    :to="{ path: $route.meta.form }"
                    :loading="isloading"
                    :disabled="isloading"
                    color="success"
                    class="mt-2"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="white--text">mdi-plus</v-icon>
                </v-btn>
            </template>
            <span>Nuevo presupuesto</span>
        </v-tooltip>
        <v-row>
            <v-col cols="12" md="8">
                <FilterComponentVue
                    :headers="filter_headers"
                    v-model="filtros_prueba"
                ></FilterComponentVue>
            </v-col>

            <v-col cols="12" md="4">
                <v-btn
                    color="primary"
                    class="white--text mr-2"
                    @click="getPresupuestos()"
                >
                    Filtrar
                </v-btn>
                <v-btn
                    color="red"
                    class="white--text mr-2"
                    @click="
                        filtros = {};
                        filtros_prueba = {};
                        getPresupuestos();
                    "
                >
                    Limpiar filtros
                </v-btn>
                <v-btn color="success" @click="ExportExcel">
                    <v-icon class="white--text">mdi-file-excel</v-icon>
                </v-btn>
            </v-col>
        </v-row>

        <v-data-table
            dense
            :headers="header_final"
            :items="Presupuestos"
            :search="search"
            :items-per-page="15"
            item-key="id"
            :item-class="getRowClass"
            class="elevation-1"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            @click:row="handleClick"
            :server-items-length="total_presupuesto"
            @update:items-per-page="ChangeSize"
            @pagination="ChangePage"
        >
            <template v-slot:item.fecha="{ item }">
                <span>{{ item.fecha | format_date }}</span>
            </template>
            <template v-slot:item.fecha_resolucion="{ item }">
                <span v-if="item.fecha_resolucion != null">{{
                    item.fecha_resolucion | format_date
                }}</span>
            </template>
            <template v-slot:item.fecha_incidencia="{ item }">
                <span v-if="item.fecha_incidencia != null">{{
                    item.fecha_incidencia | format_date
                }}</span>
            </template>
            <template v-slot:item.fecha_ejecucion="{ item }">
                <span v-if="item.fecha_ejecucion != null">{{
                    item.fecha_ejecucion | format_date
                }}</span>
            </template>
            <!-- Importe Base: Es la base imponible sin el iva -->
            <template v-slot:item.total="{ item }">
                {{ formatPrice(item.total / (1 + parseInt(item.iva) / 100)) }}
            </template>
            <template v-slot:item.pdf="{ item }">
                <a
                    target="_blank"
                    :href="`/api/pdf-presupuesto/${item.id}`"
                    @click.stop=""
                >
                    <v-icon
                        small
                        class="mr-2"
                        color="red"
                        style="font-size: 25px"
                        title="PDF"
                        >mdi-pdf-box</v-icon
                    >
                </a>
            </template>
            <template v-slot:item.action="{ item }">
                <a @click.stop="openModal(item)">
                    <v-icon
                        v-if="item.id_contrato == null"
                        small
                        class="mr-2"
                        color="red"
                        style="font-size: 25px"
                        title="BORRAR"
                        >mdi-trash-can</v-icon
                    >
                </a>
            </template>
        </v-data-table>

        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteUser()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
import FilterComponentVue from "../../../components/general/FilterComponent.vue";
import debounce from "lodash/debounce";
import { formatPrice } from "../../../helpers";

export default {
    components: {
        FilterComponentVue,
    },
    data() {
        return {
            Agentes: [],
            search: "",
            filtros: {
                validacion: 0,
            },
            headers: [
                { text: "Nº", value: "id", sortable: true },
                {
                    text: "F. Creación",
                    value: "fecha",
                    sortable: true,
                },
                {
                    text: "F. Resolución",
                    value: "fecha_resolucion",
                    sortable: true,
                },
                {
                    text: "F. Incidencia",
                    value: "fecha_incidencia",
                    sortable: true,
                },
                {
                    text: "F. Ejecución",
                    value: "fecha_ejecucion",
                    sortable: true,
                },
                {
                    text: "Comercial",
                    // value: "clientela.agentes_str",
                    value: "comercial",
                    sortable: true,
                },

                {
                    text: "Cliente",
                    // value: "clientela.nombre_comercial",
                    value: "cliente",
                    sortable: true,
                },
                { text: "Importe", value: "total", sortable: true },
                { text: "Órdenes", value: "ordenes_count", sortable: true },

                {
                    text: "Estado",
                    // value: "estado.nombre",
                    value: "estado",
                    sortable: false,
                },
                {
                    text: "Localidad",
                    // value: "clientela.dir.ciudad",
                    value: "ciudad",
                    sortable: true,
                },
                {
                    text: "C.P.",
                    // value: "clientela.dir.codigo_postal",
                    value: "codigo_postal",
                    sortable: true,
                },
                {
                    text: "Dirección",
                    // value: "clientela.dir.direccion",
                    value: "direccion",
                    sortable: true,
                },
                {
                    text: "Creador",
                    // value: "creador.name",
                    value: "creador",
                    sortable: true,
                },
                { text: "PDF", value: "pdf", sortable: true },
                { text: "Acciones", value: "action", sortable: false },
            ],
            headers2: [
                { text: "Número", value: "id", sortable: true },
                { text: "Fecha", value: "fecha", sortable: true },
                {
                    text: "Fecha de resolución",
                    value: "fecha_resolucion",
                    sortable: true,
                },
                {
                    text: "Fecha de ejecución",
                    value: "fecha_ejecucion",
                    sortable: true,
                },
                { text: "Importe base", value: "total", sortable: true },
                {
                    text: "Comercial",
                    // value: "clientela.agentes_str",
                    value: "comercial",
                    sortable: true,
                },
                {
                    text: "Nº Cliente",
                    // value: "clientela.id",
                    value: "id_cliente",
                    sortable: true,
                },
                {
                    text: "Cliente",
                    // value: "clientela.nombre_comercial",
                    value: "cliente",
                    sortable: true,
                },
                {
                    text: "CIF",
                    // value: "clientela.cif",
                    value: "cif",
                    sortable: true,
                },
                {
                    text: "Teléfono",
                    // value: "clientela.telefono",
                    value: "telefono",
                    sortable: true,
                },
                {
                    text: "Email",
                    // value: "clientela.email",
                    value: "email",
                    sortable: true,
                },
                { text: "Órdenes", value: "ordenes_count", sortable: true },

                {
                    text: "Estado",
                    // value: "estado.nombre",
                    value: "estado",
                    sortable: true,
                },
                {
                    text: "Localidad",
                    // value: "clientela.dir.ciudad",
                    value: "ciudad",
                    sortable: true,
                },
            ],
            Presupuestos: [],
            total_presupuesto: 0,
            selectedItem: 0,
            dialog: false,

            filtros_prueba: {},
            filter_headers: [
                {
                    title: "Estado",
                    type: "select",
                    active: false,
                    model: "estado",
                    item_text: "nombre",
                    item_value: "id",
                },
                {
                    title: "Comercial",
                    type: "select",
                    active: false,
                    model: "comercial",
                    item_text: "nombre",
                    item_value: "id",
                },
                {
                    title: "Fecha de creación",
                    type: "date",
                    active: false,
                    model: "fecha",
                },
                {
                    title: "Fecha de resolución",
                    type: "date",
                    active: false,
                    model: "fecha_resolucion",
                },
                {
                    title: "Fecha de incidencia",
                    type: "date",
                    active: false,
                    model: "fecha_incidencia",
                },
                {
                    title: "Fecha de ejecución",
                    type: "date",
                    active: false,
                    model: "fecha_ejecucion",
                },
            ],
            default: true,
            page: 1,
            sortBy: [],
            sortDesc: [],
            cantidad: 15,
        };
    },
    created() {
        this.addFilterAdmin();
        if (this.$store.getters.getfiltros["presupuesto"] != null) {
            this.filtros_prueba = this.$store.getters.getfiltros["presupuesto"];
        }
        this.getPresupuestos();
        this.getEstados();
        this.getAgentes();
    },
    methods: {
        ExportExcel() {
            let filtros = this.filterString;
            axios
                .get(`/api/presupuestos/excel?filtro=null${filtros}`, {
                    responseType: "blob",
                })
                .then((response) => {
                    const downloadUrl = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement("a");
                    link.href = downloadUrl;
                    link.setAttribute("download", "presupuestos.xlsx");
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                })
                .catch((error) => {
                    console.error("Error exportando presupuestos:", error);
                });
        },
        addFilterAdmin() {
            if (this.$route.meta.rol == null) {
                this.filter_headers.push({
                    title: "Excluir Pendientes/Rechazados",
                    type: "check",
                    active: false,
                    model: "excluir",
                });
                this.filtros_prueba = {
                    excluir: {
                        tipo: 1,
                        value: true,
                    },
                };
            }
        },
        ChangeSize(event) {
            this.cantidad = event;
            this.getPresupuestos();
        },
        ChangePage(event) {
            this.page = event.page;
            this.getPresupuestos();
        },
        handleClick(value) {
            this.$router.push(`/${this.$route.meta.form}?id=${value.id}`);
            //console.log(value);
        },
        getRowClass(item) {
            //if (item.revisado == 0) {
            //    return "row_red pointer";
            //}
            return "pointer";
        },
        getPresupuestos() {
            /*let filtros = this.filterString;

            if (this.sortBy && this.sortBy.length > 0) {
                sortParams = `&sort_by=${this.sortBy.join(
                    ","
                )}&sort_desc=${this.sortDesc.join(",")}`;
            }*/
            const rol =
                this.$route.meta.rol != null ? this.$route.meta.rol : "";

            axios
                /*.get(
                    `api/get-presupuestos?id=0${
                        this.$route.meta.rol != null
                            ? `&rol=${this.$route.meta.rol}`
                            : ""
                    }&page=${this.page}&amount=${this.cantidad}&validacion=${
                        this.filtros.validacion ? 1 : 0
                    }${filtros}&default=${this.default}${sortParams}`
                )*/
                .get("api/get-presupuestos", {
                    params: {
                        id: 0,
                        rol: rol,
                        page: this.page,
                        amount: this.cantidad,
                        validacion: this.filtros.validacion ? 1 : 0,
                        busqueda: this.filtros_prueba.search,
                        sort_by: this.sortBy.join(","),
                        sort_desc: this.sortDesc.join(","),
                        estado: this.filtros_prueba.estado?.value,
                        comercial: this.filtros_prueba.comercial?.value,
                        fecha_desde: this.filtros_prueba.fecha?.start,
                        fecha_hasta: this.filtros_prueba.fecha?.end,
                        fecha_resolucion_desde:
                            this.filtros_prueba.fecha_resolucion?.start,
                        fecha_resolucion_hasta:
                            this.filtros_prueba.fecha_resolucion?.end,
                        fecha_incidencia_desde:
                            this.filtros_prueba.fecha_incidencia?.start,
                        fecha_incidencia_hasta:
                            this.filtros_prueba.fecha_incidencia?.end,
                        fecha_ejecucion_desde:
                            this.filtros_prueba.fecha_ejecucion?.start,
                        fecha_ejecucion_hasta:
                            this.filtros_prueba.fecha_ejecucion?.end,
                    },
                })
                .then(
                    (res) => {
                        this.Presupuestos = res.data.data;
                        this.total_presupuesto = res.data.total;
                        this.default = true;
                    },
                    (err) => {
                        this.$custom_error(
                            "Error consultando los presupuestos"
                        );
                    }
                );
        },
        getEstados() {
            axios.get("api/get-estados-presupuestos").then((res) => {
                this.filter_headers[0].items = res.data;
            });
        },
        openModal(item) {
            this.selectedItem = this.Presupuestos.indexOf(item);
            this.dialog = true;
        },
        deleteUser() {
            axios
                .post("api/delete-presupuesto", {
                    id: this.Presupuestos[this.selectedItem].id,
                })
                .then(
                    (res) => {
                        this.$toast.sucs("Presupuesto eliminado con éxito");
                        this.dialog = false;
                        this.getPresupuestos();
                    },
                    (err) => {
                        this.$custom_error("Error eliminando el presupuesto");
                    }
                );
        },
        getAgentes() {
            axios.get(`api/get-agentes`).then(
                (res) => {
                    this.filter_headers[1].items = res.data.Agentes;
                },
                (err) => {
                    this.$custom_error("Error consultando los agentes");
                }
            );
        },
        formatPrice,
    },
    watch: {
        filtros_prueba: {
            deep: true,
            handler: function (val) {
                this.$store.dispatch("saveFiltrosPresupuesto", val);
            },
        },
        "$route.meta.rol": function (val) {
            this.addFilterAdmin();
            this.getPresupuestos();
        },
        "filtros.validacion": function (val) {
            this.getPresupuestos();
        },
        sortBy: {
            handler: debounce(function (newVal, oldVal) {
                this.getPresupuestos();
            }, 100),
            deep: true,
        },
        sortDesc: {
            handler: debounce(function (newVal, oldVal) {
                this.getPresupuestos();
            }, 100),
            deep: true,
        },
    },
    computed: {
        rol: function () {
            return localStorage.getItem("role");
        },
        header_final() {
            return this.rol == 1 ? this.headers : this.headers2;
        },
        isloading: function () {
            return this.$store.getters.getloading;
        },
        filterString() {
            let filtros = "";
            if (
                this.filtros_prueba.search != null &&
                this.filtros_prueba.search != ""
            ) {
                filtros += `&busqueda=${this.filtros_prueba.search}`;
            }
            this.filter_headers.forEach((head) => {
                if (this.filtros_prueba[head.model]) {
                    if (head.type == "date") {
                        if (
                            this.filtros_prueba[head.model].start != "" &&
                            this.filtros_prueba[head.model].start != null
                        ) {
                            filtros += `&${head.model}_desde=${
                                this.filtros_prueba[head.model].start
                            }`;
                        }
                        if (
                            this.filtros_prueba[head.model].end != "" &&
                            this.filtros_prueba[head.model].end != null
                        ) {
                            filtros += `&${head.model}_hasta=${
                                this.filtros_prueba[head.model].end
                            }`;
                        }
                    } else if (
                        (this.filtros_prueba[head.model].value != "" &&
                            this.filtros_prueba[head.model].value != null) ||
                        (this.filtros_prueba[head.model].nombre != "" &&
                            this.filtros_prueba[head.model].nombre != null)
                    ) {
                        filtros += `&${head.model}=${
                            this.filtros_prueba[head.model].value
                        }`;
                    }
                    // }
                }
            });
            return filtros;
        },
    },
};
</script>
